var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowUpBoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "14.54 14.63 185.96 175.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 187,
    height: 177
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 41L33.5 81.5L31.8329 82.2409C29.9777 83.0655 27.9366 83.3819 25.9189 83.1577C24.9766 83.053 24.051 82.8316 23.1633 82.4987L22.5145 82.2554C21.1818 81.7557 19.9471 81.0261 18.8665 80.0998C17.6346 79.0439 16.6262 77.7524 15.9006 76.3012L15.6089 75.7179C15.2048 74.9096 14.9102 74.051 14.733 73.1648C14.2598 70.799 14.6433 68.342 15.815 66.2329L16.5 65C18.4766 62.3646 21.0001 60.1882 23.8974 58.6203L103.161 15.7244C104.048 15.2448 105.007 14.9154 106.001 14.7498C106.994 14.5844 108.006 14.5844 108.999 14.7498C109.993 14.9154 110.952 15.2448 111.839 15.7244L193.065 59.6822C194.675 60.5533 196.111 61.7125 197.302 63.1022L197.502 63.3362C198.165 64.1091 198.73 64.9604 199.186 65.871C200.05 67.5999 200.5 69.5204 200.5 71.4534C200.5 72.8025 200.283 74.1525 199.856 75.4324L199.604 76.1884C199.205 77.3848 198.578 78.4924 197.757 79.4499C196.607 80.7914 195.115 81.7951 193.438 82.3539L193.162 82.4459C192.061 82.8129 190.908 83 189.748 83H188.941C187.652 83 186.368 82.8419 185.117 82.5292L185.031 82.5076C183.682 82.1706 182.382 81.6644 181.161 81.0011L107.5 41Z",
    fill: "url(#follow-up-boss-paint0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 94.5L33.5 135L31.8329 135.741C29.9777 136.565 27.9366 136.882 25.9189 136.658C24.9766 136.553 24.051 136.332 23.1633 135.999L22.5145 135.755C21.1818 135.256 19.9471 134.526 18.8665 133.6C17.6346 132.544 16.6262 131.252 15.9006 129.801L15.6089 129.218C15.2048 128.41 14.9102 127.551 14.733 126.665C14.2598 124.299 14.6433 121.842 15.815 119.733L16.5 118.5C18.4766 115.865 21.0001 113.688 23.8974 112.12L103.161 69.2244C104.048 68.7448 105.007 68.4154 106.001 68.2498C106.994 68.0844 108.006 68.0844 108.999 68.2498C109.993 68.4154 110.952 68.7448 111.839 69.2244L193.065 113.182C194.675 114.053 196.111 115.213 197.302 116.602L197.502 116.836C198.165 117.609 198.73 118.46 199.186 119.371C200.05 121.1 200.5 123.02 200.5 124.953C200.5 126.302 200.283 127.652 199.856 128.932L199.604 129.688C199.205 130.885 198.578 131.992 197.757 132.95C196.607 134.291 195.115 135.295 193.438 135.854L193.162 135.946C192.061 136.313 190.908 136.5 189.748 136.5H188.941C187.652 136.5 186.368 136.342 185.117 136.029L185.031 136.008C183.682 135.671 182.382 135.164 181.161 134.501L107.5 94.5Z",
    fill: "url(#follow-up-boss-paint1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 148L33.5 188.5L31.8329 189.241C29.9777 190.065 27.9366 190.382 25.9189 190.158C24.9766 190.053 24.051 189.832 23.1633 189.499L22.5145 189.255C21.1818 188.756 19.9471 188.026 18.8665 187.1C17.6346 186.044 16.6262 184.752 15.9006 183.301L15.6089 182.718C15.2048 181.91 14.9102 181.051 14.733 180.165C14.2598 177.799 14.6433 175.342 15.815 173.233L16.5 172C18.4766 169.365 21.0001 167.188 23.8974 165.62L103.161 122.724C104.048 122.245 105.007 121.915 106.001 121.75C106.994 121.584 108.006 121.584 108.999 121.75C109.993 121.915 110.952 122.245 111.839 122.724L193.065 166.682C194.675 167.553 196.111 168.713 197.302 170.102L197.502 170.336C198.165 171.109 198.73 171.96 199.186 172.871C200.05 174.6 200.5 176.52 200.5 178.453C200.5 179.802 200.283 181.152 199.856 182.432L199.604 183.188C199.205 184.385 198.578 185.492 197.757 186.45C196.607 187.791 195.115 188.795 193.438 189.354L193.162 189.446C192.061 189.813 190.908 190 189.748 190H188.941C187.652 190 186.368 189.842 185.117 189.529L185.031 189.508C183.682 189.171 182.382 188.664 181.161 188.001L107.5 148Z",
    fill: "url(#follow-up-boss-paint2)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 201,
    height: 200,
    fill: "url(#follow-up-boss-paint3)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "follow-up-boss-paint0",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31 15) rotate(19.0608) scale(159.23 430.383)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C6FB2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "follow-up-boss-paint1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37 122.5) rotate(-0.79297) scale(144.514 390.606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C6FB2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "follow-up-boss-paint2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37 176) rotate(-0.79297) scale(144.514 390.606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C6FB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "follow-up-boss-paint3",
    x1: 85.5,
    y1: 71.5,
    x2: 187,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3861A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpBoss);
export default __webpack_public_path__ + "static/media/follow-up-boss.21d1917a1dc07a5aa22082b822739f90.svg";
export { ForwardRef as ReactComponent };